import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";

import { AUCTION_STATES, AUCTION_CLAIM_STATES } from "../../models";

import auctionMaxBidImage from "../../assets/auction_maxbid.png";
import auctionTimeImage from "../../assets/auction_time.png";

import { W3Context } from "../../services/context";

import { countDown, formatCash } from "../../utils/util";

import "./auctionCardStyles.css";

const AuctionCard = ({
  id,
  tokenId,
  video,
  name,
  category,
  country,
  countryCode,
  point,
  tier,
  state,
  owner,
  startDate,
  expirationDate,
  bestBid,
  bids,
  initialValue,
  currentValue,
  userHasBids,
  auctioneerState,
}) => {
  const { account } = useContext(W3Context);

  const targetTime = expirationDate ? new Date(expirationDate).getTime() : 0;

  const [time, setTime] = useState(countDown(targetTime, false));
  const [hasStarted, setHasStarted] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);

  const priceFormatted =
    bestBid && bestBid.value
      ? formatCash(bestBid.value) + " GEO$"
      : currentValue
      ? formatCash(currentValue) + " GEO$"
      : "0 GEO$";

  useEffect(() => {
    const now = new Date();
    const sDate = startDate ? new Date(startDate) : null;
    if (sDate) {
      setHasStarted(sDate <= now);
    }

    const eDate = expirationDate ? new Date(expirationDate) : null;
    if (eDate) {
      setHasEnded(eDate <= now);
    }
  }, [expirationDate, startDate]);

  return (
    <>
      <Card className="auction-card">
        <Card.Header className="auction-card-header">
          <video
            style={{ borderRadius: "10px" }}
            src={video}
            alt="NFT"
            type="video/mp4"
            controls
            autoPlay
            muted
            loop
            playsInline
          />
        </Card.Header>
        <Card.Body className="auction-card-body">
          <Card.Title className="auction-card-title mb-2">
            <Row className="align-items-center text-left">
              <Col xs={3}>
                <img className="country" src={country} alt="flag" />
              </Col>
              <Col xs={9}>
                <span className="name">{name}</span>
              </Col>
            </Row>
          </Card.Title>
          <Row className="justify-content-center align-items-center mx-auto info-input-background mb-2">
            <Col xs={12} className="info-input">
              <Row className="justify-content-center align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-center p-0">
                  <img src={auctionMaxBidImage} alt="max-bid" />
                </Col>
                <Col xs={{ span: 7 }} className="text-left p-0">
                  <span>{priceFormatted}</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="justify-content-center align-items-center mx-auto info-input-background mb-2">
            <Col xs={12} className="info-input">
              <Row className="justify-content-center align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-center p-0">
                  <img src={auctionTimeImage} alt="time-to-finish" />
                </Col>
                <Col xs={{ span: 7 }} className="text-left p-0">
                  <span>{`${time.day}d ${time.hour}h ${time.minute}m`}</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
        <Card.Footer className="auction-card-footer text-center">
          {hasStarted && state === AUCTION_STATES.ACTIVE ? (
            <>
              {bestBid && bestBid.wallet !== account && userHasBids ? (
                <div className="black-border">
                  <div className="background bg-red">
                    <Link
                      to={{
                        pathname: `${tokenId}`,
                      }}
                    >
                      <button className="mx-auto red">
                        YOU WERE OUTBIDDED
                      </button>
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="black-border">
                  <div className="background bg-purple">
                    <Link
                      to={{
                        pathname: `${tokenId}`,
                      }}
                    >
                      <button className="mx-auto purple">VIEW AUCTION</button>
                    </Link>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              {hasEnded ? (
                <>
                  {owner === account ? (
                    <>
                      {bids && bids.length > 0 ? (
                        <div className="black-border">
                          <div className="background bg-green">
                            <Link
                              to={{
                                pathname: `${tokenId}`,
                              }}
                            >
                              <button className="mx-auto green">
                                CLAIM GEO$ NOW
                              </button>
                            </Link>
                          </div>
                        </div>
                      ) : (
                        <>
                          {auctioneerState ===
                          AUCTION_CLAIM_STATES.CLAIMABLE ? (
                            <div className="black-border">
                              <div className="background bg-green">
                                <Link
                                  to={{
                                    pathname: `${tokenId}`,
                                  }}
                                >
                                  <button className="mx-auto green">
                                    CLAIM NFT
                                  </button>
                                </Link>
                              </div>
                            </div>
                          ) : (
                            <div className="black-border">
                              <div className="background bg-blue">
                                <Link
                                  to={{
                                    pathname: `${tokenId}`,
                                  }}
                                >
                                  <button className="mx-auto blue">
                                    START AUCTION
                                  </button>
                                </Link>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {bestBid && bestBid.wallet === account && (
                        <div className="black-border">
                          <div className="background bg-green">
                            <Link
                              to={{
                                pathname: `${tokenId}`,
                              }}
                            >
                              <button className="mx-auto green">
                                CLAIM NOW
                              </button>
                            </Link>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  {!state && owner === account ? (
                    <div className="black-border">
                      <div className="background bg-blue">
                        <Link
                          to={{
                            pathname: `${tokenId}`,
                          }}
                        >
                          <button className="mx-auto blue">
                            START AUCTION
                          </button>
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="black-border">
                      <div className="background bg-purple">
                        <Link
                          to={{
                            pathname: `${tokenId}`,
                          }}
                        >
                          <button className="mx-auto purple">
                            VIEW AUCTION
                          </button>
                        </Link>
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </Card.Footer>
      </Card>
    </>
  );
};

export default AuctionCard;
